import { getActualCategory } from '@bridebook/web/app-basic/lib/search/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useSupplierBucketSetting } from '@bridebook/web/app-basic/lib/hooks/use-supplier-bucket-setting';
import { useABTest_HideLimitedProfiles } from '@bridebook/web/app-basic/lib/ab-tests/tests/LIVE-27960_HideLimitedProfiles';

export const useHideLimitedProfiles = () => {
  const actualCategory = useSelector(getActualCategory);

  const { variant } = useABTest_HideLimitedProfiles();

  const { isEnabled } = useSupplierBucketSetting('hideLimitedProfiles', actualCategory);

  return variant !== 'control' && isEnabled;
};
